import React from 'react'
import SvgIcon from 'components/SvgIcon'

const IconProfile = props => (
  <SvgIcon viewBox="0 0 32 33.76" {...props}>
    <ellipse
      stroke="currentColor"
      fill="currentColor"
      transform="rotate(-45.001 15.812 10.774)"
      cx="15.81"
      cy="10.77"
      rx="4.86"
      ry="4.86"
    />
    <path
      fill="currentColor"
      d="M15.97 1.04C7.29 1.04.23 8.1.23 16.77s7.06 15.74 15.74 15.74 15.74-7.06 15.74-15.74S24.65 1.04 15.97 1.04zm7.9 27.01c.03-.16.04-.32.04-.49 0-5.71-3.84-10.3-8.1-10.3s-8.1 4.59-8.1 10.3c0 .08.01.16.02.24-3.36-2.52-5.54-6.51-5.54-11.02C2.19 9.18 8.37 3 15.97 3s13.78 6.18 13.78 13.78c0 4.65-2.33 8.77-5.88 11.27z"
    />
  </SvgIcon>
)

export default IconProfile
